import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Input, Select, Popover } from 'antd';
import type { InputRef } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { usePaymentArrangement, usePaymentMethod, useIdType, useBankCode } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { AgreementCard } from './Agreement/AgreementCard';
import generateKey from 'utils/generateKey';
import { isLocaleEnglish } from 'utils/languageUtils';
import visa from 'assets/images/MakeRequest/visa.svg';
import tanhao from 'assets/images/MakeRequest/tanhao.svg';
import visaafter from 'assets/images/MakeRequest/visaafter.svg';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
import {
  // formatCardNumber2,
  //  formatCardNumber4,
  formatIdlast5,
} from 'utils/formate/cardNumber';
import moment from 'moment';
import { VerifyCreditCard, isValidHongKongNonPermanentID, validateHKID, isValidChinaID } from '../../../utils';
import Visibility from 'assets/images/eye-open.svg';
import VisibilityOff from 'assets/images/eye-off.svg';
export const ChangePaymentContactCard = forwardRef(
  (
    props: {
      policyTypesObject: { label: string; label2: string; value: string }[];
      errorMessage: string;
      policyNumber: string;
      companyCode: string;
      Message: string;
    },
    ref,
  ) => {
    const { t, i18n } = useTranslation();
    const form = useFormInstance();
    const { token } = useKeycloakReady();
    const [key, setKey] = useState<string>('cahduashdiagdia');
    const { data: paymentMethod, shouldFetch: shouldFetchPaymentMethod } = usePaymentMethod(token || '');
    const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token || '');
    // const { data: paymentMode, shouldFetch: shouldFetchPaymentMode } = usePaymentMode(token || '');
    const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
    const isEnglish = isLocaleEnglish(i18n.language);
    const [RenewalMethod, setRenewalMethod] = useState<string>();
    const [showcard, setshowcard] = useState<string>();
    const [
      showCardMask,
      // setShowCardMask
    ] = useState<boolean>(true);
    const [
      showCardNoMask,
      // setShowCardNoMask
    ] = useState<boolean>(true);
    const [showIdCard, setShowIdCard] = useState<boolean>(true);
    const [
      originValue,
      // setOriginValue
    ] = useState<string>(form.getFieldValue('bankAccountNumber'));
    const [
      cardOriValue,
      // setCardOriValue
    ] = useState<string>(form.getFieldValue('CreditCard'));
    const [idValue, setIdValue] = useState<string>(form.getFieldValue('passport'));
    const inputRef = useRef<InputRef>(null);
    const [paymentModeList, setPaymentModeList] = useState<
      {
        label: string;
        value: string;
        codeList: string[];
        idcode: string;
        labelTc: string;
      }[]
    >([]); // 修改为数组类型
    const [paymentMethodList, setPaymentMethodList] = useState<
      {
        label: string;
        value: string;
        code: string;
        valueTc: string;
        valueEn: string;
      }[]
    >([]); //methodList
    const [newPaymentMethodList, setNewPaymentMethodList] = useState<
      {
        label: string;
        value: string;
        code: string;
        valueTc: string;
        valueEn: string;
      }[]
    >([]); //xuanrandemethodList
    const {
      data: ArrangeInformation,
      shouldFetch: ContactInformationShouldFetch,
      error: ArrangeInfoError,
    } = usePaymentArrangement(key, token || '', props.policyNumber, props.companyCode);
    useEffect(() => {
      setKey(generateKey());
      if (props.policyNumber) {
        shouldFetchPaymentMethod(true);
        ContactInformationShouldFetch(true);
      }
    }, [ContactInformationShouldFetch, props.policyNumber, shouldFetchPaymentMethod]);
    useEffect(() => {
      if (ArrangeInformation && !ArrangeInfoError) {
        const list = ArrangeInformation.premiumFrequencyData?.map((item) => {
          return {
            label: isEnglish ? item.description : item.descriptionTc,
            value: item.description,
            codeList: item.paymentMethodData,
            idcode: item.premiumFrequencyCode,
            labelTc: item.descriptionTc,
          };
        });
        setPaymentModeList(list);
        // 使用list而不是paymentModeList来避免异步问题
        const selectedItem = list.find((item) => item.idcode == ArrangeInformation.paymentMode);
        if (selectedItem) {
          const codelist = selectedItem.codeList;
          const filteredList = paymentMethodList.filter((item) => codelist.includes(item.code));
          setNewPaymentMethodList(filteredList);
        }
      }
    }, [ArrangeInfoError, ArrangeInformation, paymentMethodList, isEnglish, cardOriValue]);
    useEffect(() => {
      shouldFetchIdType(true);
    }, [shouldFetchIdType]);
    useEffect(() => {
      setRenewalMethod(form.getFieldValue('paymentMethoddf'));
      // shouldFetchPaymentMode(true);
    }, [setRenewalMethod, form]);
    useEffect(() => {
      shouldFetchBankList(true);
    }, [shouldFetchBankList]);
    useImperativeHandle(ref, () => ({
      getOriginValue: () => {
        return originValue; // 返回子组件的值
      },
      getCardOriginValue: () => {
        return cardOriValue; // 返回子组件的值
      },
      getIdOriginValue: () => {
        return idValue;
      },
    }));
    const myBankList: { label: string; value: string }[] = [];
    bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
      myBankList.push({
        label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
        value: item.bankCode,
      });
    });

    const idTypeList: { label: string; value: string }[] = [];
    idType?.map((item: { idTypeDesc: string; idTypeDescTc: string; idType: string }) => {
      idTypeList.push({
        label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
        value: item.idTypeDesc,
      });
    });
    useEffect(() => {
      if (paymentMethod) {
        const list = paymentMethod.map((item) => {
          return {
            label: isEnglish ? item.description : item.descriptionTc,
            value: item.description,
            code: item.paymentMethodCode,
            valueTc: item.descriptionTc,
            valueEn: item.description,
          };
        });
        setPaymentMethodList(list);
      }
    }, [paymentMethod, isEnglish]);
    // useEffect(() => {
    //   if (form.getFieldValue('bankCode') == '') {
    //     form.setFieldsValue({
    //       bankCode: '003',
    //     });
    //   }
    // }, [form]);

    const paymentModeChange = (e: string) => {
      console.log(e);

      const selectedItem = paymentModeList.find((item) => item.value == e);
      form.setFieldsValue({
        paymentMode: selectedItem?.label,
        paymentModeTc: selectedItem?.labelTc,
      });
      form.setFieldsValue({
        paymentModedf: selectedItem?.idcode,
      });
      form.setFieldsValue({
        paymentModeEn: e,
      });
      if (selectedItem) {
        const codelist = selectedItem.codeList;
        const filteredList = paymentMethodList.filter((item) => codelist.includes(item.code));
        console.log('filteredList', filteredList);
        setNewPaymentMethodList(filteredList);
      }
      console.log('eeeee', e);
    };
    const RenewalPaymentMethodchange = (e: string) => {
      setshowcard('');
      const list = newPaymentMethodList.filter((item) => item.value == e);
      console.log('090909', list);
      form.setFieldsValue({
        paymentMethoddf: list[0]?.code,
      });
      form.setFieldsValue({
        RenewalPaymentMethod: e,
      });
      form.setFieldsValue({
        RenewalPaymentMethoden: e,
      });
      form.setFieldsValue({
        RenewalPaymentMethodtc: list[0]?.valueTc,
      });
      console.log('000000000', form.getFieldValue('paymentMethoddf'));
      setRenewalMethod(list[0]?.code);
    };
    const expiryDateonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      console.log("e.target.value')", e.target.value);
      const value = e.target.value;
      if (!value) return value;
      const valueArr = value.replace(/\D/g, '').split('');
      if (valueArr.length <= 2) {
        console.log('valueArr', valueArr.join('').replace(/(\d{2})(\d{0,2})/, '$1/$2'));
        const a = valueArr.join('').replace(/(\d{2})(\d{0,2})/, '$1/$2');
        form.setFieldsValue({
          expiryDate: a,
        });
        return valueArr.join('').replace(/(\d{2})(\d{0,2})/, '$1/$2');
      }
      console.log('valueArr222', valueArr.slice(0, 2).join('') + '/' + valueArr.slice(2, 6).join(''));
      const b = valueArr.slice(0, 2).join('') + '/' + valueArr.slice(2, 6).join('');
      form.setFieldsValue({
        expiryDate: b,
      });
      return valueArr.slice(0, 2).join('') + '/' + valueArr.slice(2, 6).join('');
    };
    // 辅助函数：计算去除空格后的光标位置
    // const getRawCursorPosition = (value: string, cursorPos: number) => {
    //   return value.slice(0, cursorPos).replace(/\s/g, '').length;
    // };
    // 辅助函数：计算格式化后的光标位置
    // const getFormattedCursorPosition = (rawValue: string, formattedValue: string, rawCursorPos: number) => {
    //   // 前 rawCursorPos 个字符在格式化字符串中的位置
    //   let formattedPos = 0;
    //   let count = 0;

    //   for (let i = 0; i < formattedValue.length; i++) {
    //     if (count >= rawCursorPos) break;

    //     if (formattedValue[i] !== ' ') {
    //       count++;
    //     }
    //     formattedPos++;
    //   }

    //   return formattedPos;
    // };
    const CreditCardchage = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value != form.getFieldValue('CreditCardOrigin')) {
        setshowcard('V');
      } else {
        setshowcard('');
      }
      // 记录光标位置（格式化前）
      // const input = e.target;
      // const originalValue = input.value.replace(/\s/g, '');
      // const cursorPos = input.selectionStart || 0;

      // 格式化前原始值中的光标位置（去除空格后的位置）
      // const rawCursorPos = getRawCursorPosition(input.value, cursorPos);

      // const formattedValue = originalValue.replace(/[^0-9*X]/g, '');
      // .match(/.{1,4}/g)
      // ?.join(' ') || '';

      // const value = e.target.value
      //   .replace(/\s/g, '')
      //   .replace(/[^0-9*X\s]/g, '')
      //   .replace(/(\d{4})(?=\d)/g, '$1 ');
      // setCardOriValue(value);
      // form.setFieldsValue({
      //   CreditCard: value,
      // });
      // 更新表单值
      // setCardOriValue(formattedValue);
      // form.setFieldsValue({ CreditCard: formattedValue });
      // requestAnimationFrame(() => {
      //   if (!inputRef.current?.input) return;

      //   // 计算格式化后的光标位置
      //   const newCursorPos = getFormattedCursorPosition(originalValue, formattedValue, rawCursorPos);

      //   inputRef.current.input.setSelectionRange(newCursorPos, newCursorPos);
      // });
    };

    const branchNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value != form.getFieldValue('bankAccountNumberOrigin')) {
        setshowcard('D');
      } else {
        setshowcard('');
      }
      const value = e.target.value.replace(/[^0-9*X]/g, '');
      // setOriginValue(value);

      return value;
    };
    const changeIdvalue = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setIdValue(value);
      return value;
    };

    // const changeCardMask = (e: React.MouseEvent) => {
    //   e.stopPropagation();
    //   setShowCardMask(!showCardMask);
    // };
    const changeIdCard = (e: React.MouseEvent) => {
      e.stopPropagation();
      setShowIdCard(!showIdCard);
    };
    // const changeCardNoMask = (e: React.MouseEvent) => {
    //   e.stopPropagation();
    //   setShowCardNoMask(!showCardNoMask);
    // };
    // const changeEye = () => {
    //   if (showCardMask && form.getFieldValue('bankAccountNumber')) {
    //     form.setFieldsValue({
    //       bankAccountNumber: formatCardNumber2(originValue),
    //     });
    //   } else {
    //     form.setFieldsValue({
    //       bankAccountNumber: originValue,
    //     });
    //   }
    // };
    useEffect(() => {
      // if (originValue) changeEye();
      if (idValue) IdCardBlur();
      // if (cardOriValue) creditNoBlur();
      // eslint-disable-next-line
    }, [showCardMask, showCardNoMask, showIdCard]);
    // const bankNoBlur = () => {
    //   changeEye();
    // };
    const IdCardBlur = () => {
      if (showIdCard && form.getFieldValue('passport')) {
        form.setFieldsValue({
          passport: formatIdlast5(idValue),
        });
      } else {
        form.setFieldsValue({
          passport: idValue,
        });
      }
    };
    // const creditNoBlur = () => {
    //   if (showCardNoMask && form.getFieldValue('CreditCard')) {
    //     form.setFieldsValue({
    //       CreditCard: formatCardNumber4(cardOriValue),
    //     });
    //   } else {
    //     form.setFieldsValue({
    //       CreditCard: cardOriValue,
    //     });
    //   }
    // };
    return (
      <Row>
        <Row
          justify="center"
          gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
          style={{ rowGap: 0 }}
          className="ChangePaymentContactCard"
        >
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              style={{ borderBottom: '1px solid #CCC' }}
              rules={[{ required: true, message: t('life.MakeRequest.payment.Paymentmode') }]}
              required
              label={
                <div
                  className="CreditCardNumber"
                  style={{
                    color: '#6f7072',
                    fontWeight: 'normal',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>{t('life.MakeRequest.payment.Paymentmode')}</div>
                  <div>
                    {ArrangeInformation?.paymentModeDisable && (
                      <Popover placement="leftBottom" content={`${t('life.MakeRequest.payment.Alert')}`}>
                        <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                      </Popover>
                    )}
                  </div>
                </div>
              }
              name="paymentMode"
            >
              <Select
                onChange={paymentModeChange}
                popupClassName="slectop2"
                disabled={ArrangeInformation?.paymentModeDisable}
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  fontWeight: 'normal',
                  marginBottom: '24px',
                  padding: '4px 0',
                }}
              >
                {paymentModeList &&
                  paymentModeList.map((item) => (
                    <Select.Option key={item.label} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
              </Select>
            </BoldLabelFormItem>
          </Col>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              style={{ borderBottom: '1px solid #CCC', marginBottom: RenewalMethod == 'C' ? '10px' : '24px' }}
              rules={[{ required: true, message: t('life.MakeRequest.payment.Renewal') }]}
              required
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.MakeRequest.payment.Renewal')}
                </span>
              }
              name="RenewalPaymentMethod"
            >
              <Select
                popupClassName="slectop2"
                onChange={RenewalPaymentMethodchange}
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  fontWeight: 'normal',
                  marginBottom: '24px',
                  padding: '4px 0',
                }}
              >
                {newPaymentMethodList &&
                  newPaymentMethodList.map((item) => (
                    <Select.Option key={item.label} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
              </Select>
            </BoldLabelFormItem>
          </Col>

          {RenewalMethod == 'V' && (
            <Row
              justify="center"
              gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
              style={{ rowGap: 0 }}
              className="ChangePaymentContactCard"
            >
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('life.MakeRequest.payment.AccountHolder') }]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.AccountHolder')}
                    </span>
                  }
                  name="accountHolder"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.payment.AccountHolder')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '0 10px',
                    }}
                  />
                </BoldLabelFormItem>
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  rules={[
                    { required: true, message: t('life.MakeRequest.payment.CreditCardNumber') },
                    {
                      validator: (_, value) => {
                        if (value) {
                          const pattern = new RegExp('^[45]\\d{15}$');
                          // if (!pattern.test(cardOriValue.replace(/ /g, ''))) {
                          if (!pattern.test(value.replace(/ /g, ''))) {
                            return Promise.reject(new Error(t('life.MakeRequest.payment.critcartrule')));
                          }
                          // if (!VerifyCreditCard(cardOriValue)) {
                          if (!VerifyCreditCard(value)) {
                            return Promise.reject(new Error(t('life.MakeRequest.payment.cardInvalid')));
                          }
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  required
                  label={
                    <div
                      className="CreditCardNumber"
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>{t('life.MakeRequest.payment.CreditCardNumber')}</div>
                      <div>
                        <img src={visa} style={{ margin: '0  2px 0 10px', width: '40px', height: '14px' }} />
                        <img src={visaafter} style={{ margin: '0  2px 0 10px', width: '40px', height: '14px' }} />
                      </div>
                    </div>
                  }
                  name="CreditCard"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.payment.CreditCardNumber')}
                    onChange={CreditCardchage}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '0 10px',
                    }}
                    // onBlur={creditNoBlur}
                    // onFocus={() => form.setFieldValue('CreditCard', cardOriValue)}
                    ref={inputRef}
                    // suffix={
                    //   showCardNoMask ? (
                    //     <img src={Visibility} onClick={(e) => changeCardNoMask(e)} />
                    //   ) : (
                    //     <img src={VisibilityOff} onClick={(e) => changeCardNoMask(e)} />
                    //   )
                    // }
                  />
                </BoldLabelFormItem>
                {props.errorMessage == 'xapi.policy.CreditCardNumber.has.been.used' && (
                  <div>
                    <span
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#C21b17',
                      }}
                    >
                      {props.Message}
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px' }}>
                <BoldLabelFormItem
                  rules={[
                    {
                      validator: (rule, value) => {
                        const today = moment();
                        const [month, year] = value ? value.split('/') : [];

                        if (!value) {
                          return Promise.reject(new Error(t('life.MakeRequest.payment.CreditCardDate')));
                        }

                        // 校验月份 MM：必须是01-12
                        if (!month || month < 1 || month > 12) {
                          return Promise.reject(new Error(t('life.MakeRequest.payment.dateError')));
                        }

                        // 校验年份 YYYY：必须大于等于当前年份
                        if (!year || parseInt(year) < today.year()) {
                          return Promise.reject(new Error(t('life.MakeRequest.payment.dateError')));
                        }

                        // 校验 MM/YYYY 必须大于等于今天的日期
                        const inputDate = moment(`${year}-${month}-01`);
                        if (inputDate.isBefore(today, 'month')) {
                          return Promise.reject(new Error(t('life.MakeRequest.payment.dateError')));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.CreditCardDate')}
                    </span>
                  }
                  name="expiryDate"
                >
                  <Input
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '0 10px',
                    }}
                    placeholder={t('life.MakeRequest.payment.CreditCardDateLABEL')}
                    maxLength={7}
                    onChange={expiryDateonChange}
                  />
                </BoldLabelFormItem>
              </Col>
              {/* <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                    {t('life.MakeRequest.payment.AutopayStatus')}
                  </span>
                }
                name="AutopayStatus"
              >
                <div
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #CCCCCC',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  {form.getFieldValue('AutopayStatus')}
                </div>
              </BoldLabelFormItem>
            </Col> */}
            </Row>
          )}
          {/* =================================== */}
          {RenewalMethod == 'D' && (
            <Row
              justify="center"
              gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
              style={{ rowGap: 0 }}
              className="ChangePaymentContactCard"
            >
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.BankCode')}
                    </span>
                  }
                  name="bankCode"
                >
                  <Select
                    popupClassName="slectop2"
                    placeholder={t('life.MakeRequest.payment.BankCodeholder')}
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                    }}
                    showSearch
                    filterOption={(input, bank) => (bank?.key ?? '').toLowerCase().includes(input.toLowerCase())}
                  >
                    {myBankList &&
                      myBankList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>
              </Col>
              {/* <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                    {t('life.MakeRequest.payment.AutopayStatus')}
                  </span>
                }
                name="AutopayStatus"
              >
                <div
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #CCCCCC',
                    // color: "white",
                    backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  {form.getFieldValue('AutopayStatus')}
                </div>
              </BoldLabelFormItem>
            </Col> */}
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  required
                  rules={[
                    { required: true, message: t('common.error.requiredField') },
                    { pattern: /^\d{3}$/, message: t('life.MakeRequest.payment.InvalidBranchNumber') },
                  ]}
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.BranchNumber')}
                    </span>
                  }
                  name="branchNumber"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.payment.BranchNumber')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '0 10px',
                    }}
                  />
                </BoldLabelFormItem>
              </Col>
              <Col xs={24} md={24}>
                <BoldLabelFormItem
                  rules={[
                    { required: true, message: t('common.error.requiredField') },
                    {
                      // /^\d{1,9}$/
                      // pattern: /^[\d*]+$/,
                      pattern: /^\d{1,9}$/,
                      message: t('life.MakeRequest.payment.InvalidBankAccountNumber'),
                    },
                  ]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.BankAccountNumber')}
                    </span>
                  }
                  name="bankAccountNumber"
                >
                  <Input
                    size="middle"
                    onChange={branchNumberChange}
                    placeholder={t('life.MakeRequest.payment.BankAccountNumber')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '4px 10px',
                    }}
                    // onBlur={bankNoBlur}
                    // onFocus={() => {
                    //   form.setFieldValue('bankAccountNumber', originValue);
                    // }}
                    // suffix={
                    //   showCardMask ? (
                    //     <img src={Visibility} onClick={(e) => changeCardMask(e)} />
                    //   ) : (
                    //     <img src={VisibilityOff} onClick={(e) => changeCardMask(e)} />
                    //   )
                    // }
                  />
                </BoldLabelFormItem>
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    color: '#6F7072',
                    width: '100%',
                    marginBottom: '25px',
                  }}
                >
                  <div>
                    <span>{t('life.MakeRequest.payment.policyholderAccount')}</span>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.AccountHolderName')}
                    </span>
                  }
                  name="accountHolder"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.payment.AccountHolderName')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '4px 10px',
                    }}
                  />
                </BoldLabelFormItem>
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.IDType')}
                    </span>
                  }
                  name="IDtype"
                >
                  <Select
                    popupClassName="slectop2"
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                      padding: '10px 0',
                    }}
                  >
                    {idTypeList &&
                      idTypeList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>
              </Col>
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px' }}>
                <BoldLabelFormItem
                  rules={[
                    { required: true, message: t('common.error.requiredField') },
                    {
                      validator(_, value) {
                        if (!value) {
                          return Promise.resolve();
                        }
                        let flag = true;
                        if (value) {
                          if (form.getFieldValue('IDtype') == 'HK Permanent ID') {
                            flag = validateHKID(idValue);
                          } else if (form.getFieldValue('IDtype') == 'HK Non-Permanent ID') {
                            flag = isValidHongKongNonPermanentID(idValue);
                          } else if (form.getFieldValue('IDtype') == 'China ID') {
                            flag = isValidChinaID(idValue);
                          } else {
                            flag = true;
                          }
                          if (flag) {
                            return Promise.resolve();
                          } else return Promise.reject(new Error(t('life.MakeRequest.payment.IdNumber')));
                        }
                      },
                    },
                  ]}
                  required
                  label={
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                      {t('life.MakeRequest.payment.IDCard')}
                    </span>
                  }
                  name="passport"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.payment.IDCard')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      padding: '0 10px',
                    }}
                    onBlur={IdCardBlur}
                    onFocus={() => form.setFieldValue('passport', idValue)}
                    onChange={changeIdvalue}
                    suffix={
                      showIdCard ? (
                        <img src={Visibility} onClick={(e) => changeIdCard(e)} />
                      ) : (
                        <img src={VisibilityOff} onClick={(e) => changeIdCard(e)} />
                      )
                    }
                  />
                </BoldLabelFormItem>
              </Col>
            </Row>
          )}
          {/* =================================== */}
          <Col xs={24} md={24}>
            <div
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                color: '#6F7072',
                borderBottom: '1px solid #CCCCCC',
                width: '100%',
                paddingBottom: '10px',
              }}
            >
              {/* <div> */}
              <span>{t('life.MakeRequest.contact.terms')}</span>
              {/* </div> */}
            </div>
            <div style={{ fontSize: '17px', fontFamily: 'Roboto400', paddingTop: '15px', color: '#20252b' }}>
              <span>{t('life.MakeRequest.contact.termstittle')}</span>
            </div>
          </Col>
          <Col xs={24} md={24}>
            <AgreementCard />
          </Col>
          <div
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              paddingLeft: '2px',
              paddingTop: '15px',
              color: '#20252b',
            }}
          >
            <span>{t('life.MakeRequest.contact.accepttext2')}</span>
          </div>
          <Col xs={24} md={24}>
            {showcard == 'V' && (
              <div>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    paddingTop: '15px',
                    color: '#20252b',
                    paddingLeft: '2px',
                  }}
                >
                  <div>{t('life.MakeRequest.payment.creditcardonly1')}</div>
                </div>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    paddingTop: '15px',
                    color: '#20252b',
                    paddingLeft: '2px',
                  }}
                >
                  <div>{t('life.MakeRequest.payment.creditcardonly2')}</div>
                </div>
              </div>
            )}
            {showcard == 'D' && (
              <div>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    paddingTop: '15px',
                    color: '#20252b',
                    paddingLeft: '2px',
                  }}
                >
                  <div>{t('life.MakeRequest.payment.bankAccount1')}</div>
                </div>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    paddingTop: '15px',
                    color: '#20252b',
                    paddingLeft: '2px',
                  }}
                >
                  <div>{t('life.MakeRequest.payment.bankAccount2')}</div>
                  <div>{t('life.MakeRequest.payment.bankAccount21')}</div>
                  <div>{t('life.MakeRequest.payment.bankAccount22')}</div>
                  <div>{t('life.MakeRequest.payment.bankAccount23')}</div>
                  <div>{t('life.MakeRequest.payment.bankAccount24')}</div>
                  <div>{t('life.MakeRequest.payment.bankAccount25')}</div>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Row>
    );
  },
);
ChangePaymentContactCard.displayName = 'ChangePaymentContactCard';
